import { Component } from '@angular/core';

@Component({
  selector: 'common-back-icon',
  templateUrl: './back-icon.component.svg',
  styleUrls: ['./back-icon.component.scss'],
})
export class BackIconComponent {}
